export default {
  methods: {
    toHours(minutes) {
        if (minutes === null || minutes === undefined) {
            return null;
        }
        return minutes / 60;
    },
  }
};
